export const selectApiBodyRequestDictionary = (valueOptionMessage, name, address, selectDictionaryId) => {

    const requestList = {
        'vessel' : { name: name, country_id: selectDictionaryId },
        'port' : { name: name, city_id: selectDictionaryId },
        'shipper' : { name: name, address: address },
        'shipowner' : { name: name, address: address },
        'city' : { name: name, country_id: selectDictionaryId  }
    }

    for (let key in requestList) {
        if (valueOptionMessage === key) {
            return requestList[key];
        }
    }

    return selectApiBodyRequestDictionary;
}